import { Cog, Stethoscope, FlaskConical, Code2, TrendingUp, Scale, Brain, Palette, Megaphone, Compass } from "lucide-react";

const MAP = { Cog, Stethoscope, FlaskConical, Code2, TrendingUp, Scale, Brain, Palette, Megaphone };

export default function Icon({ name, ...props }) {
  const C = MAP[name] || Compass;
  return <C {...props} />;
}
